export default "__VITE_ASSET__BQIBQFmf__"